import { Select, MenuItem, Box } from "@mui/material";
import { QuestionCard } from "../mobilePreview.style";

type Props = {
  currentQuestion: any;
};

const DropdownPreview = ({ currentQuestion }: Props) => {
  const { choices } = currentQuestion;

  return (
    <>
      <Box sx={QuestionCard}>
        <Select fullWidth id="position" defaultValue={""}>
          {choices?.map((choice: any) => (
            <MenuItem key={choice?.id} value={choice.id}>
              {choice.label}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </>
  );
};
export default DropdownPreview;
